import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import app from 'flarum/forum/app';
import username from 'flarum/common/helpers/username';
import listItems from 'flarum/helpers/listItems';
import AvatarEditor from 'flarum/components/AvatarEditor';
import SignUpModal from 'flarum/components/SignUpModal';

export default class WelcomeBoxt extends Widget {
  view() {
    return this.content(); // 只渲染内容本身，不要 Afrux 默认的 wrapper
  }

  content() {
    const user = app.session.user;
    const lastSeenAt = user?.lastSeenAt() !== null ? user?.lastSeenAt() : false;
    const userLang = app.translator.getLocale();
    const useWidget = app.forum.attribute('justoverclock-welcomebox.UseWidget');
    const isGuestBoxHidden = app.forum.attribute('HideGuestBox');
    const SettingsLink = app.route('settings');
    const ImgAvatar =
      app.forum.attribute('imgUrl') || app.forum.attribute('baseUrl') + '/assets/extensions/justoverclock-welcomebox/no-avatar.png';

    if (useWidget && user) {
      return (
        <li className="item-WelcomeBox">
          <div className="containerwb">
            <div className="backgrwb">
              <div>
                  <div className="avatarwb">{AvatarEditor.component({ user })}</div>
                <div className="contentwb">
                  <div className="textinfo">
                    {app.translator.trans('flarum-ext-welcomebox.forum.wback')}
                    <br />
                    <strong>{username(user)}</strong>
                  </div>
                </div>
                <div className="iconbadge">{listItems(user.badges().toArray())}</div>
              </div>
            </div>
          </div>
        </li>
      );
    } else if (!user && isGuestBoxHidden && useWidget) {
      return (
        <li className="item-WelcomeBox">
          <div className="containerwb">
            <div className="backgrwbguest">
              <img className="guestavatarimg" src={ImgAvatar} />
              <div className="guesttext">{app.translator.trans('flarum-ext-welcomebox.forum.welcomeguest')}</div>
              <p className="guestdesc">{app.translator.trans('flarum-ext-welcomebox.forum.notregistered')}</p>
              <button
                className="SplitDropdown-button Button Button--primary hasIcon"
                type="button"
                onclick={() => app.modal.show(SignUpModal)}
              >
                {app.translator.trans('core.forum.header.sign_up_link')}
              </button>
              <div className="contentwb" />
            </div>
          </div>
        </li>
      );
    }

    return null;
  }
}
